export default "__VITE_ASSET__XOL6CqWV__"